/**
 * RegVyd Application Configuration
 *
 * Global configuration constants used across the application.
 * Add new config values here to keep them centralized.
 */

// Supported currencies
export const CURRENCIES = ['CZK', 'EUR', 'USD'];

// Default currency
export const DEFAULT_CURRENCY = 'CZK';
